var TypedError = require('error/typed');

/**
 * Error thrown from backend.
 * Contains errorcode, message and related api url.
 *
 * ApiError can be created with:
 *
 * new Apierror({
 *  code: "BACKEND_ERROR",
 *  msg: "Backend errored",
 *  url: "some/endpoint"
 * })
 *
 * */
let ApiError = TypedError({
  type: 'api',
  message: `Api error: code: [{code}], message: [{msg}], url: [{url}]'`,
  msg: null,
  code: null,
  url: null,
});

export default ApiError;
